import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const getAdminForm = async (id: number) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(
        // @ts-ignore
        routable.getRoute('adminCommunicationItemUsersReport'),
        {
            _itemId_: id,
        }
    );

    try {
        // @ts-ignore
        loader.show();
        const response = await $api.get(url);
        // @ts-ignore
        loader.hide();
        return response.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error?.response?.data);
        return error.message;
    }
};
